export type MembershipCounterEvidenceStatus =
  | 'PASS'
  | 'FAIL'
  | 'UNVERIFIED';

export interface MembershipCounterRuntimeEvidenceProjection {
  title: string;
  subsystem: 'membership';
  authorityDomain: 'membership-dashboard-counters';
  status: MembershipCounterEvidenceStatus;
  evidenceSource:
    'live-database-rpc-and-repository-certification';

  rpc: 'get_membership_dashboard_counters';
  migration:
    'mae_004a_membership_counter_authority';

  ownerSeatIncluded: true;
  planCapacities: readonly [1, 5, 10, 30];

  activeSponsoredCounter: true;
  reservedSponsoredCounter: true;
  occupiedSeatCounter: true;
  availableSponsoredCounter: true;
  returnedSponsoredCounter: true;

  totalInviteCounter: true;
  familyInviteCounter: true;
  pendingInviteCounter: true;
  acceptedInviteCounter: true;
  expiredInviteCounter: true;

  claimedProfileCounter: true;
  unclaimedProfileCounter: true;

  familyInvitesUnlimited: true;
  sponsoredReservationDays: 7;

  browserDerivedCounterPathRemoved: true;
  existingDashboardReused: true;
  duplicateDashboardPrevented: true;
  failClosedOnAuthorityError: true;

  plannedDashboardDestination:
    'Settings → Membership & Family Access';
  treePageRetainsInviteShortcut: true;
  relocationScheduledAfterCounterAuthority: true;

  constitutionalRule: string;
  nextMilestone: string;
  verifiedAt: string;
}

export function projectMembershipCounterRuntimeEvidence():
  MembershipCounterRuntimeEvidenceProjection {
  return Object.freeze({
    title:
      'Membership Counter Runtime Authority',
    subsystem: 'membership',
    authorityDomain:
      'membership-dashboard-counters',
    status: 'PASS',
    evidenceSource:
      'live-database-rpc-and-repository-certification',

    rpc: 'get_membership_dashboard_counters',
    migration:
      'mae_004a_membership_counter_authority',

    ownerSeatIncluded: true,
    planCapacities: [1, 5, 10, 30],

    activeSponsoredCounter: true,
    reservedSponsoredCounter: true,
    occupiedSeatCounter: true,
    availableSponsoredCounter: true,
    returnedSponsoredCounter: true,

    totalInviteCounter: true,
    familyInviteCounter: true,
    pendingInviteCounter: true,
    acceptedInviteCounter: true,
    expiredInviteCounter: true,

    claimedProfileCounter: true,
    unclaimedProfileCounter: true,

    familyInvitesUnlimited: true,
    sponsoredReservationDays: 7,

    browserDerivedCounterPathRemoved: true,
    existingDashboardReused: true,
    duplicateDashboardPrevented: true,
    failClosedOnAuthorityError: true,

    plannedDashboardDestination:
      'Settings → Membership & Family Access',
    treePageRetainsInviteShortcut: true,
    relocationScheduledAfterCounterAuthority: true,

    constitutionalRule:
      'Family identity is permanent. Capabilities are licensed. Resources are governed.',
    nextMilestone:
      'MAE-004C — Membership Counter Completion Gate',
    verifiedAt: '2026-07-16',
  });
}

export const MEMBERSHIP_COUNTER_RUNTIME_EVIDENCE_READY =
  true;
